<!-- Message Display -->
<div
    class="message-container"
    *ngIf="displayMessage"
>
    <div class="alert-message">
        <mat-icon>info</mat-icon>
        <span>{{ message }}</span>
    </div>
</div>

<!-- Statistics Table -->
<div class="statistics-container">
    <mat-card class="table-card">
        <div class="table-header">
            <h3 class="table-title">Betstop Status</h3>
            <div>
                <mat-form-field appearance="fill">
                    <mat-label>Reason</mat-label>
                    <input
                        matInput
                        type="text"
                        [(ngModel)]="reason"
                        required
                    />
                </mat-form-field>
            </div>
            <div>
                <button
                    mat-icon-button
                    (click)="refresh()"
                    class="refresh-btn"
                    matTooltip="Refresh"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>

        <div class="mat-table-holder">
            <table
                mat-table
                [dataSource]="dataSourcebetstopStatusTable"
                class="mat-elevation-z2"
            >
                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Status
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="status-cell"
                    >
                        <span
                            class="status-badge"
                            [ngClass]="{
                                'status-blocked': element.status === 1,
                                'status-unblocked': element.status === 0
                            }"
                        >
                            <mat-icon>{{
                                element.status === 1 ? 'block' : 'check_circle'
                            }}</mat-icon>
                            {{ element.status === 1 ? 'Stopped' : 'Started' }}
                        </span>
                    </td>
                </ng-container>

                <!-- Client Name Column -->
                <ng-container matColumnDef="clientName">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Client Name
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.clientName }}
                    </td>
                </ng-container>

                <!-- Reason Column -->
                <ng-container matColumnDef="reasonForBlocking">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Reason
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.reasonForBlocking }}
                    </td>
                </ng-container>

                <!-- Block DateTime Column -->
                <ng-container matColumnDef="blockDateTime">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Stop Date/Time
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="date-cell"
                    >
                        {{
                            element.blockDateTime
                                ? (element.blockDateTime
                                  | date: 'dd/MM/yyyy HH:mm')
                                : '-'
                        }}
                    </td>
                </ng-container>

                <!-- Blocked By Column -->
                <ng-container matColumnDef="blockedBy">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Stop By
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.blockedBy || '-' }}
                    </td>
                </ng-container>

                <!-- Unblock DateTime Column -->
                <ng-container matColumnDef="unblockDateTime">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Start Date/Time
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="date-cell"
                    >
                        {{
                            element.unblockDateTime
                                ? (element.unblockDateTime
                                  | date: 'dd/MM/yyyy HH:mm')
                                : '-'
                        }}
                    </td>
                </ng-container>

                <!-- Unblocked By Column -->
                <ng-container matColumnDef="unblockedBy">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Start By
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.unblockedBy || '-' }}
                    </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Action
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        <button
                            mat-icon-button
                            color="warn"
                            *ngIf="element.status === 0"
                            (click)="stop(element.clientUuid)"
                        >
                            Stop
                        </button>
                        <button
                            mat-icon-button
                            color="primary"
                            *ngIf="element.status === 1"
                            (click)="start(element.clientUuid)"
                        >
                            Start
                        </button>
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="columnsBetstop; sticky: true"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: columnsBetstop"
                    class="clickable-row"
                ></tr>
            </table>
        </div>
    </mat-card>
</div>
